<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row class="mb-5">
        <v-col cols="12">
          <span class="font-weight-medium primary--text">Datos generales</span>
          <span class="font-italic ml-3 primary--text">* Campos requeridos</span>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Nombre"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              label="Nombre *"
              placeholder="Nombre"
              v-model="broker.name"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-account-tie"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Código"
            rules="required|alpha_num|max:25"
            v-slot="{ errors }"
          >
            <v-text-field
              label="Código *"
              placeholder="Código"
              v-model="broker.code"
              dense
              maxlength="25"
              :error-messages="errors[0]"
              append-icon="mdi-check-bold"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Portal URL"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              label="Portal URL *"
              placeholder="Portal URL *"
              v-model="broker.portal"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-web"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Correo de contacto"
            rules="email|required"
            v-slot="{ errors }"
          >
            <v-text-field
              label="Correo de contacto *"
              placeholder="Correo de contacto"
              v-model="broker.contact_email"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-email"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Teléfono principal"
            rules="required|min:6"
            v-slot="{ errors }"
          >
            <phone-input
              label="Teléfono principal *"
              placeholder="Teléfono principal *"
              v-model="broker.main_phone"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-phone"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Teléfono secundario"
            rules=""
            v-slot="{ errors }"
          >
            <phone-input
              label="Teléfono secundario"
              placeholder="Teléfono secundario"
              v-model="broker.secondary_phone"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-phone"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider name="Dirección" rules="" v-slot="{ errors }">
            <v-text-field
              label="Dirección"
              placeholder="Dirección"
              v-model="broker.address"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-map-marker"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider name="Facebook" rules="" v-slot="{ errors }">
            <v-text-field
              label="Facebook"
              placeholder="Facebook"
              v-model="broker.facebook"
              maxlength="50"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-facebook"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider name="Twitter" rules="" v-slot="{ errors }">
            <v-text-field
              label="Twitter"
              placeholder="Twitter"
              v-model="broker.twitter"
              maxlength="50"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-twitter"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider name="Instagram" rules="" v-slot="{ errors }">
            <v-text-field
              label="Instagram"
              placeholder="Instagram"
              v-model="broker.instagram"
              maxlength="50"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-instagram"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>

<script>
import WizardForm from '@/components/commons/WizardForm'
import PhoneInput from '@/components/commons/PhoneInput'

export default {
  components: { WizardForm, PhoneInput },
  props: {
    broker: {
      type: Object,
      required: true
    }
  }
}
</script>
